const doc = [({"en":({"js":({"admin":({"call_lists":({"call_mode":({"call_list_entity_carousel":({"no_other_contacts_available_for_call":"No other contacts available for call"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;